import { IoIosSearch } from 'react-icons/io';
import type { SearchConfig } from '@eliadmin/core/src/components/header/search-bar/search-config-types';

export const SEARCH_CONFIG: SearchConfig = {
  mode: 'drawer',
  field: {
    leadingIcon: <IoIosSearch size={18} className="text-[#9CA3AF]" />,
    placeholderKey: 'text1406',
    buttonIcon: <IoIosSearch size={20} className="text-black" />,
    buttonVariant: 'none',
    buttonSize: 'icon',
    buttonClassName: 'border border-neutral-200 bg-white ea-search-bar__popover-search',
    inputWrapperClassName: 'h-12 rounded-full border-none bg-neutral-50 pr-0 ea-search-bar__input',
    className: {
      root: 'overflow-hidden rounded-full',
      input: {
        main: 'pl-[38px] text-sm font-normal placeholder:text-[#9CA3AF] lg:text-sm',
        before: 'pl-3',
        after: 'p-0',
      },
    },
  },
};
